import script from "./filterDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./filterDropdown.vue?vue&type=script&setup=true&lang=js"

import "./filterDropdown.vue?vue&type=style&index=0&id=3faf1c44&lang=css"

const __exports__ = script;

export default __exports__